import ImageWmsLayer from "@avinet/adaptive-ui-maps/layer/ImageWmsLayer";
import OsmLayer from "@avinet/adaptive-ui-maps/layer/OsmLayer";
import TileWmsLayer from "@avinet/adaptive-ui-maps/layer/TileWmsLayer";
import WmtsLayer from "@avinet/adaptive-ui-maps/layer/WmtsLayer";
import { LayerContent, SourceType } from "../../types/Content";
import { AdaptiveLayerLoader } from "./AdaptiveLayer";

interface LayersProps {
  layers: LayerContent[];
}

const Layers = ({ layers }: LayersProps) => {
  return (
    <>
      {layers.map((layer) => {
        switch (layer.sourceType) {
          case SourceType.wms:
            if (layer.single)
              return (
                <ImageWmsLayer
                  key={layer.id}
                  url={layer.uri}
                  opacity={layer.opacity}
                  params={layer.params}
                  format={layer.format}
                  minZoom={layer.minZoom}
                  maxZoom={layer.maxZoom}
                  version={layer.version}
                  layers={layer.layers}
                />
              );
            return (
              <TileWmsLayer
                key={layer.id}
                url={layer.uri}
                opacity={layer.opacity}
                params={layer.params}
                format={layer.format}
                minZoom={layer.minZoom}
                maxZoom={layer.maxZoom}
                version={layer.version}
                layers={layer.layers}
              />
            );

          case SourceType.wmts:
            return (
              <WmtsLayer
                key={layer.id}
                url={layer.uri}
                opacity={layer.opacity}
                format={layer.format}
                minZoom={layer.minZoom}
                maxZoom={layer.maxZoom}
                layer={layer.layers}
                matrixSet={layer.matrixSet}
                style={layer.layerStyle}
              />
            );

          case SourceType.adaptive:
            const { themeUuid, themeType } = layer;
            return (
              <AdaptiveLayerLoader
                key={layer.id}
                themeUuid={themeUuid}
                themeType={themeType}
              />
            );

          case SourceType.osm:
            return <OsmLayer key={layer.id} opacity={layer.opacity} />;
        }
      })}
    </>
  );
};

export default Layers;
